import { render, staticRenderFns } from "./CoTwoClap.vue?vue&type=template&id=450ffdf3&scoped=true&"
import script from "./CoTwoClap.vue?vue&type=script&lang=js&"
export * from "./CoTwoClap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450ffdf3",
  null
  
)

export default component.exports